import { trackEvent } from '~/features/analytics/track-event';
import type { BackToSchool2026SaleVariant } from '~/features/promotions/constants/back-to-school-2026-sale';

import type { PromoCampaignSurfaceRenderers } from '../types';

import { BackToSchool2026PromoBanner } from './back-to-school-2026-promo-banner';
import { BackToSchool2026PromoCard } from './back-to-school-2026-promo-card';
import { buildBackToSchool2026ExperienceCard } from './experience-card';

const BTS_2026_SALE_ANALYTICS_LABEL = 'back_to_school_2026_sale_clicked';

export const backToSchool2026CampaignSurfaces: PromoCampaignSurfaceRenderers<BackToSchool2026SaleVariant>['surfaces'] =
  {
    homepage: ({ resolved, promoCode, imagePriority }) => (
      <BackToSchool2026PromoCard
        imagePriority={imagePriority}
        promoCode={promoCode}
        variant={resolved}
        onClick={() =>
          trackEvent({
            type: 'click',
            name: 'Homepage CTA Clicked',
            label: BTS_2026_SALE_ANALYTICS_LABEL,
          })
        }
      />
    ),
    catalog: ({ resolved, promoCode, imagePriority }) => (
      <BackToSchool2026PromoBanner
        imagePriority={imagePriority}
        promoCode={promoCode}
        variant={resolved}
        onCtaClick={() =>
          trackEvent({
            type: 'click',
            name: 'Catalog Page CTA Clicked',
            label: BTS_2026_SALE_ANALYTICS_LABEL,
          })
        }
      />
    ),
    experience: ({ resolved, promoCode }) => buildBackToSchool2026ExperienceCard(resolved, promoCode),
  };
